<script lang="ts">
  // *** This file is part of DbGate Premium ***

  import FormStyledButton from '../buttons/FormStyledButton.svelte';
  import TableControl from '../elements/TableControl.svelte';
  import FormCheckboxField from '../forms/FormCheckboxField.svelte';

  import FormProvider from '../forms/FormProvider.svelte';
  import FormSubmit from '../forms/FormSubmit.svelte';
  import ModalBase from './ModalBase.svelte';
  import { closeCurrentModal } from './modalTools';

  export let onConfirm;
  export let rollbackAfterFinish = false;
  export let items = [];
</script>

<FormProvider initialValues={{ rollbackAfterFinish }}>
  <ModalBase {...$$restProps}>
    <svelte:fragment slot="header">Confirm data deploy</svelte:fragment>

    Are you sure to deploy following tables into database?

    <FormCheckboxField label="Dry run - no changes (rollback when finished)" name="rollbackAfterFinish" />

    <div class="tablewrap scroll">
      <TableControl
        stickyHeader
        rows={items}
        columns={[
          {
            fieldName: 'name',
            header: 'Name',
          },
          {
            fieldName: 'actions',
            header: 'Actions',
          },
        ]}
      />
    </div>

    <svelte:fragment slot="footer">
      <FormSubmit
        value="Deploy data"
        on:click={e => {
          closeCurrentModal();
          onConfirm(e.detail);
        }}
        data-testid="ConfirmDataDeployModal_okButton"
      />
      <FormStyledButton
        type="button"
        value="Close"
        on:click={closeCurrentModal}
        data-testid="ConfirmDataDeployModal_closeButton"
      />
    </svelte:fragment>
  </ModalBase>
</FormProvider>

<style>
  .tablewrap {
    max-height: 300px;
  }
</style>
